import { api } from './configs/axiosConfig';

const endPoint = "/quotation";

export const quotationAPI = {
    saveQuotationDetails: async function (quotationDetails) {
        const reponse = await api.request({
            url: `${endPoint}/details`,
            method: 'POST',
            data: quotationDetails
        });

        return reponse.data;
    },

    getCustomers: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: `${endPoint}/customers`,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },

    getCurrency: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: `${endPoint}/currency`,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },

    getSalesRep: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: `${endPoint}/sales_rep`,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },

    getItems: async function (searchKey, pCode) {
        const reponse = await api.request({
            url: `${endPoint}/items`,
            method: 'GET',
            params: { searchKey, pCode }
        });

        return reponse.data;
    },

    getItemDetails: async function (pCode, itemCode) {
        const reponse = await api.request({
            url: `${endPoint}/item_details`,
            method: 'GET',
            params: { pCode, itemCode }
        });

        return reponse.data;
    },

    saveMeasurements: async function (measurements) {
        const reponse = await api.request({
            url: `${endPoint}/measurements`,
            method: 'POST',
            data: measurements
        });

        return reponse.data;
    },

    getAllQuotation: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: `${endPoint}/all`,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    },

    getQuotationDetails: async function (pCode, quotationNo) {
        const reponse = await api.request({
            url: `${endPoint}/get-details`,
            method: 'GET',
            params: { pCode, quotationNo }
        });

        return reponse.data;
    },

    getAllQuotationItems: async function (searchKey, pCode, quotationNo) {
        const reponse = await api.request({
            url: `${endPoint}/quotation-items`,
            method: 'GET',
            params: { searchKey, pCode, quotationNo }
        });

        return reponse.data;
    },

}